module.exports = __webpack_public_path__ + "img/rongguang.9a3d979d.png";